var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.921,
    height: 29.921,
    viewBox: "0 0 29.921 29.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#272d3b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.002 0.611)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.787,33.245l-5.863-5.863a1.8,1.8,0,0,0-2.538,0l-1.525,1.525a1.8,1.8,0,0,0-.454,1.767l-.575.575h0c-.408.409-2.953-.219-6.028-3.294s-3.7-5.618-3.294-6.028h0l.576-.576a1.8,1.8,0,0,0,1.767-.454l1.525-1.525a1.8,1.8,0,0,0,0-2.538L6.514,10.973a1.795,1.795,0,0,0-2.538,0L2.451,12.5A1.8,1.8,0,0,0,2,14.265s-.488.492-.512.523c-1.622,1.8-1.926,4.641-.851,8.035a25.575,25.575,0,0,0,6.391,9.911,25.578,25.578,0,0,0,9.911,6.391,12.4,12.4,0,0,0,3.717.633,6.182,6.182,0,0,0,4.52-1.675l.32-.32a1.8,1.8,0,0,0,.5.071,1.783,1.783,0,0,0,1.269-.526l1.525-1.525A1.8,1.8,0,0,0,28.787,33.245Zm-23.542-21L11.108,18.1,9.584,19.63h0l-.022-.022L6.652,16.7,3.721,13.766ZM23.906,36.814h0c-1.291,1.291-3.573,1.5-6.426.6a23.768,23.768,0,0,1-9.184-5.95,23.767,23.767,0,0,1-5.95-9.184c-.9-2.853-.691-5.135.6-6.427h0l.162-.162,4.55,4.55-.417.417h0c-1.729,1.731.348,5.619,3.295,8.565,2.205,2.205,4.938,3.924,6.9,3.924a2.266,2.266,0,0,0,1.667-.63h0l.417-.417,4.55,4.55Zm2.088-.775L20.13,30.176l1.525-1.525,5.863,5.863S25.994,36.04,25.993,36.039Z",
    transform: "translate(-0.002 -10.447)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.437 4.552)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M271.406,80.538a8.978,8.978,0,0,0-6.39-2.647.9.9,0,0,0,0,1.795,7.242,7.242,0,0,1,7.242,7.242.9.9,0,1,0,1.795,0A8.978,8.978,0,0,0,271.406,80.538Z",
    transform: "translate(-264.118 -77.891)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.437)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M274.619,3.98A13.5,13.5,0,0,0,265.009,0a.9.9,0,1,0,0,1.795A11.794,11.794,0,0,1,276.8,13.589a.9.9,0,0,0,1.795,0A13.5,13.5,0,0,0,274.619,3.98Z",
    transform: "translate(-264.112 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.437 9.104)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M268.189,157.1a4.4,4.4,0,0,0-3.171-1.314h0a.9.9,0,0,0,0,1.795h0a2.6,2.6,0,0,1,1.9.788,2.637,2.637,0,0,1,.788,1.9.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9A4.4,4.4,0,0,0,268.189,157.1Z",
    transform: "translate(-264.121 -155.783)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.677a3828098fa7a0cdde75e4ea964aed.svg";
export { ForwardRef as ReactComponent };